import { useEffect,useState,useContext } from "react";
import {
    useNavigate  } from "react-router-dom";
  import $ from "jquery";
  import { Card,ListGroup} from 'react-bootstrap';
  import {BsBookmarkStar} from 'react-icons/bs';
  import UserContext  from '../../contexts/UserContext';
  import ProfileCard from "../Profiles/ProfileCard";

  const Home = (props) => {
    const navigate = useNavigate();
    const {user,setUser} = useContext(UserContext);
    const [totalTakhmeen,setTotalTakhmeen] = useState(null); 
    const [date,setDate] = useState([])
    const [days,setDays] = useState([]);
    const [day,setDay] = useState(null);
    const [niyaaz,setNiyaaz] = useState(null);

  async function getDataForUser(){
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getUsersSession",
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
        success : function(response){
        if(response && response.user){
            setUser(response.user);
        }else{
          setUser(null)
          navigate("/login");
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
    })
    }

    async function getData(userId){
        await $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            if(response && response.user){
               setUser(response.user);
            }else{
              navigate("/login",{state:{message:"Please Login !"}})
            }
    
          },
          error: function(err){
              console.log("error")
              console.log(err)
              navigate("/login",{state:{message:"Something went wrong !"}})
          }
      })
      }

      function getMenu(){
        $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/menus",
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            if(response.days){
            setDays(response.days)
            setDate(response.dates)
          }else{ 
            navigate("/login");
          }
            
          },
          error: function(err){
              console.log("error")
              console.log(err)
              navigate("/login")
          }
        })
      }

      function getTodayNiyaaz(){
        $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/todayNiyaz/"+new Date().toDateString(),
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            if(!response.message){
              setNiyaaz(response[0])
            }
          },
          error: function(err){
              console.log("error")
              console.log(err)
          }
        })
      }

      async function tomorrowMenu(){
        let tomDate = new Date();
        tomDate.setDate(new Date().getDate()+1);
        if(date.indexOf(tomDate.toDateString())-1>=0){
          setDay(days[date.indexOf(tomDate.toDateString())-1])
        }
      }

      function calculateTotalTakhmeen(userData){
        if(totalTakhmeen === null){
            let totalAmount = 0;
            if(userData){
              userData.takhmeen.map((takhmeen)=>{
                  totalAmount = takhmeen.amount + totalAmount;
              })
            }
            setTotalTakhmeen(totalAmount)
        }
        
    }  
      
    useEffect(()=>{
      try{
        if(!user && (typeof localStorage !== 'undefined') && localStorage.getItem('userSession')){
          getData(JSON.parse(localStorage.getItem('userSession')))
        }else{
          if(!user){
            getDataForUser();
          }
        }
      }
      catch(e){
        getDataForUser();
      }
      getMenu();
      if(!(niyaaz && niyaaz.date && niyaaz.date.includes(new Date().toDateString()))){
        getTodayNiyaaz()
      }
    },[])

    useEffect(()=>{  
      tomorrowMenu()
    },[days])

    const NiyaazCard = () => {
      const design = (
        <>
        {
          niyaaz?
          <div className="achievement-card">
            <div className="achievement-icon ms-0 me-2">
              <BsBookmarkStar />
            </div>
            <div className="achievement-details">
              <div className="recipient-name">Aqa Moula(TUS) Ni Khushi aney Tulul Umr ni Niyat si , Today's Niyaaz Khidmat By : </div>
              <div className="achievement-title mt-1">{niyaaz.name}</div>
            </div>
          </div>
          :
          null
        }
        </>
      )
      return design;
    }


    const design = (
        <>
{user? 
<>
<NiyaazCard/>
<ProfileCard user={user}/>
    {user.takhmeen.length>0?
    (<div className="small-cards">
      <div className="card-sm-container">
        <div className="card-content">
          <p> Takhmeen<br/>{user.takhmeen[user.takhmeen.length-1].year}</p>
          <p className="amount">₹{user.takhmeen[user.takhmeen.length-1].amount}</p>
        </div>
      </div>
      {calculateTotalTakhmeen(user)}
      <div className="card-sm-container">
        <div className="card-content">
          <p>Total Hub Due</p>
          <p className="amount">₹{totalTakhmeen - user.hubPaid}</p>
        </div>
      </div>
    </div>):null}

    <Card className="mb-4 mt-4 mx-3">
      <Card.Header>Menu For Tomorrow</Card.Header>
      <ListGroup variant="flush">
          {
            day && day.items && day.items.length>0 && !day.items[0].label?
            day.items.map((items,i)=>{
                return <ListGroup.Item key={i}>{items}</ListGroup.Item>
            }):
            <ListGroup.Item>No Thaali {day && day.items[0] && day.items[0].label && day.items[0].label.length>0 ? '- '+ day.items[0].label.toString(): null }</ListGroup.Item>

          }
      </ListGroup>
    </Card>
</>
    :null}
        </>
    )


    return design;
}

export default Home;